function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
document.addEventListener('DOMContentLoaded', function () {
  loadMetaObjects();
});
document.addEventListener('shopify:section:load', function () {
  loadMetaObjects();
});

// Get all items and build the groups
function loadMetaObjects() {
  // get list elements of the initial load
  var carouselWrapper = document.querySelector('.metaobject__items .carousel-wrapper');
  if (!carouselWrapper) return;
  var carouselViewport = carouselWrapper.querySelector('[data-items-element="swiper__viewport"]');
  var carouselSwiper = carouselWrapper.querySelector('[data-items-element="swiper-wrapper"]');
  var sectionId = document.querySelector('.metaobject-list').id;
  var groups = document.querySelectorAll('.metaobject-index__group');
  // object that holds all of the loaded content
  var pageParam = carouselWrapper.dataset.pageParam;
  var numPages = parseInt(carouselWrapper.dataset.pages, 10) || 1;
  var pagesLoaded = [];
  var allCards = new DocumentFragment();
  // if there are groups, add the initial cards into allCards to be appended to groups
  if (groups.length > 0) {
    var cards = document.querySelectorAll('.metaobject-card');
    var _iterator = _createForOfIteratorHelper(cards),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var card = _step.value;
        allCards.append(card);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  if (numPages > 1) {
    for (var i = 2; i <= numPages; i++) {
      pagesLoaded[i - 2] = false;
    }
    // fetch and append all paginated content
    loadPages(pageParam, numPages, sectionId);
  } else {
    addItems();
  }
  function loadPages(pageParam, numPages, sectionId) {
    for (var _i = 2; _i <= numPages; _i++) {
      var fetchUrl = "".concat(window.location.origin).concat(window.location.pathname, "?").concat(pageParam, "=").concat(_i, "&section=").concat(sectionId);
      fetchItems(_i - 2, fetchUrl);
    }
  }

  // fetch the next page, add the cards to the main list
  function fetchItems(index, url) {
    fetch(url).then(function (response) {
      return response.text();
    }).then(function (responseText) {
      var html = new DOMParser().parseFromString(responseText, 'text/html');
      var cards = html.querySelectorAll('.metaobject-card');
      var _iterator2 = _createForOfIteratorHelper(cards),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _card = _step2.value;
          allCards.append(_card);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      pagesLoaded[index] = true;
      var allLoaded = true;
      var _iterator3 = _createForOfIteratorHelper(pagesLoaded),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var loaded = _step3.value;
          if (loaded === false) {
            allLoaded = false;
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (allLoaded) {
        addItems();
      }
    })["catch"](function (error) {
      console.error(error);
    });
  }

  // add items from js structure to html elements
  function addItems() {
    var _document$querySelect, _document$querySelect2;
    // Convert DocFrag into an array so we can sort
    var cardArray = Array.from(allCards.children);
    // sort alphabetically
    cardArray.sort(function (a, b) {
      var nameA = a.dataset.item.toLowerCase() || '';
      var nameB = b.dataset.item.toLowerCase() || '';
      // return sorted data
      return nameA.localeCompare(nameB);
    });
    // Clear allCards and re-append in sorted order
    allCards = new DocumentFragment();
    cardArray.forEach(function (card) {
      return allCards.append(card);
    });
    if (groups.length > 0) {
      separateItemsIntoGroups();
      document.querySelector('.metaobject__items').remove();
    } else {
      carouselSwiper.append(allCards);
    }
    // remove spinner and unhide the main section
    document.querySelector('.metaobject-index__spinner').remove();
    (_document$querySelect = document.querySelector('.metaobject-index__wrapper')) === null || _document$querySelect === void 0 || _document$querySelect.classList.remove('hidden');
    (_document$querySelect2 = document.querySelector('.metaobject-index__group-wrapper')) === null || _document$querySelect2 === void 0 || _document$querySelect2.classList.remove('hidden');
  }

  // separate the items from the main list into separate groups
  function separateItemsIntoGroups() {
    groups.forEach(function (group) {
      var groupLetters = group.getAttribute('data-index').split(',');
      var groupWrapper = group.querySelector('.carousel-wrapper');
      var swiper = groupWrapper === null || groupWrapper === void 0 ? void 0 : groupWrapper.querySelector('[data-items-element="swiper-wrapper"]');
      if (!groupWrapper) {
        var wrapper = carouselWrapper.cloneNode(false);
        var viewport = carouselViewport.cloneNode(false);
        swiper = carouselSwiper.cloneNode(false);
        viewport.append(swiper);
        wrapper.append(viewport);
        // support content container when titles are set to left
        var groupContent = group === null || group === void 0 ? void 0 : group.querySelector('.metaobject-index__group-content');
        if (!groupContent) {
          groupContent = group;
        }
        if (groupContent.querySelector('.accordion__content')) {
          groupContent.querySelector('.accordion__content').append(wrapper);
        } else {
          groupContent.append(wrapper);
        }
      }
      for (var _i2 = 0; _i2 < groupLetters.length; _i2++) {
        var letter = groupLetters[_i2].toLowerCase();
        var letterItems = allCards.querySelectorAll(".metaobject-card[data-item^=".concat(CSS.escape(letter), "]"));
        letterItems.forEach(function (item) {
          swiper.append(item);
        });
        // unhide group, divider, and anchors that have existing items
        if (letterItems.length > 0) {
          group.classList.remove('hidden');
          var divider = document.querySelector(".metaobject-index__group-divider_".concat(group.id));
          divider === null || divider === void 0 || divider.classList.remove('hidden');
          var anchors = document.querySelectorAll('.metaobject-index__anchor');
          var _iterator4 = _createForOfIteratorHelper(anchors),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var anchor = _step4.value;
              if (anchor.dataset.letter.toLowerCase().includes(letter)) {
                anchor.classList.remove('hidden');
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }
    });
  }
}